import { hasQueryStringVar } from './module/inject-common';
import { log } from './module/log';

type PixelsSetupParam = {
  pageId: string;
};

let publisherId: string;
let pixelsPageId: string;
let pixelsVideoId: string;
let isProd = true;
const ENABLED_ON_PROD = true;
const EMBED_TAG_PATTERN =
  'https://cdn.fcp.codes/embed-code-template/embed-code-template.js?publisher=4f11dd1d-50ac-4d01-9d05-602b4d6cb9e5#PIXELS_';
const isProdCheck = (domain: string) => /pub.pixels.ai/.test(domain);
const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

try {
  // this won't work on IE 11 and below but I don't think it matters
  // because we don't support them?
  let currentSrc = document.currentScript?.getAttribute('src');
  if (!currentSrc.startsWith('http')) {
    currentSrc = window.location.origin + currentSrc;
  }
  isProd = isProdCheck(currentSrc);
  const assetUrl = new URL(currentSrc);

  publisherId = assetUrl.searchParams.get('id');
} catch (exception) {
  console.error(exception);
}
log('pixels', 'inject', 'publisherId', publisherId);

const playerDivId = 'pixels_inject_video_player_inner';
let pixelsInjectVideoPlayerOpacity = 0;
let pixelsInjectVideoPlayer: HTMLDivElement;

const convertMediaId = (tagOrId: string) => {
  if (tagOrId.startsWith('<script')) {
    // old style full embed tag, so extract href from it...
    return extractHrefFromTag(tagOrId);
  } else {
    // new style id, so build embed tag href...
    return buildEmbedTagHrefFromMediaId(tagOrId);
  }
};

const extractHrefFromTag = (tag: string) => {
  const parts = tag.split("'");
  return parts[1];
};

const buildEmbedTagHrefFromMediaId = (id: string) => {
  return `${EMBED_TAG_PATTERN}${id}`;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getArticleVideoMatch = async (pixelsPageId: string) => {
  if (hasQueryStringVar('has_match')) {
    // hardcoded example FCPlayer video embed tag...
    log('pixels', 'injecting test match...');
    return convertMediaId('6338829779112');
  }
  //  let pixelsVideoId;
  log('pixels', 'video match lookup disabled');
  // const endpoint = new URL(pixelsMatchBaseUrl);
  // endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + `/${publisherId}/${pixelsPageId}`;
  // log('pixels', 'endpoint', endpoint.toString());
  // const data = await (await fetch(endpoint.toString())).json();
  // if (data.status === 404) {
  //   log('pixels', 'inject match NOT found');
  // } else {
  //   pixelsVideoId = convert_media_id(data.videoId);
  //   log('pixels', 'inject match found', pixelsVideoId);
  // }
  // return pixelsVideoId;
  return;
};

// add player script
const pixelsInjectLoadPlayer = () => {
  const fcplayerScript = document.createElement('script');
  fcplayerScript.defer = true;
  // set script src to the video id which contains the full html embed tag
  fcplayerScript.src = pixelsVideoId;
  const el = document.getElementById(playerDivId);
  el.appendChild(fcplayerScript);
};

// fade up black rect
const pixelsInjectFadeUp = () => {
  if (pixelsInjectVideoPlayerOpacity < 1) {
    pixelsInjectVideoPlayerOpacity += 0.1;
    setTimeout(() => pixelsInjectFadeUp(), 25);
  } else {
    pixelsInjectLoadPlayer();
  }
  pixelsInjectVideoPlayer.style.opacity = '' + pixelsInjectVideoPlayerOpacity;
};

const injectVideo = (pixelsInjectTag: string) => {
  // get hero image on page
  const pixelsInjectHeroImage = document.querySelector(pixelsInjectTag) as HTMLElement;
  pixelsInjectHeroImage.style.position = 'relative';
  const pixelsInjectHeroImageRect = pixelsInjectHeroImage.getBoundingClientRect();

  // add invisible black rect over hero image
  pixelsInjectVideoPlayer = document.createElement('div');
  pixelsInjectVideoPlayer.style.backgroundColor = 'black';
  pixelsInjectVideoPlayer.style.position = 'absolute';
  pixelsInjectVideoPlayer.style.width = '100%';
  pixelsInjectVideoPlayer.style.height = '100%';
  pixelsInjectVideoPlayer.style.top = '0';
  pixelsInjectVideoPlayer.style.opacity = '0';
  pixelsInjectHeroImage.appendChild(pixelsInjectVideoPlayer);

  // add div for player holder
  // set marginTop to percentage to account for resizing...
  const marginTop =
    ((pixelsInjectHeroImageRect.height - pixelsInjectHeroImageRect.width * 0.5625) /
      2 /
      pixelsInjectHeroImageRect.width) *
    100;
  const pixelsInjectVideoPlayerGolder = document.createElement('div');
  pixelsInjectVideoPlayerGolder.style.marginTop = marginTop + '%';
  pixelsInjectVideoPlayer.appendChild(pixelsInjectVideoPlayerGolder);

  // add div for player inner
  const pixelsInjectVideoPlayerInner = document.createElement('div');
  pixelsInjectVideoPlayerInner.id = playerDivId;
  pixelsInjectVideoPlayerGolder.appendChild(pixelsInjectVideoPlayerInner);

  // start fade up
  pixelsInjectFadeUp();
};

function pixelsInject(elementId: string) {
  return {
    setup: async (options: PixelsSetupParam, callback: (x: boolean) => void) => {
      pixelsPageId = options?.pageId;
      // only inject video in test envs for now...
      if (ENABLED_ON_PROD || !isProd) {
        if (pixelsPageId) {
          pixelsVideoId = await getArticleVideoMatch(pixelsPageId);
          // only inject if we have a video...
          if (pixelsVideoId) {
            window.top[window.top.__pixelsLayerKey || 'pixelsLayer'].swappedVideoId = pixelsVideoId;
            // allow some time for host page to settle before querying hero image rect...
            log('pixels', 'inject called with pixelsPageId and pixelsVideoId', pixelsPageId, pixelsVideoId);
            await sleep(250);
            injectVideo(elementId);
          }
        }
      } else {
        log('pixels', 'not running on prod...');
      }
      callback(!!pixelsVideoId);
    },
  };
}

window.pixelsInject = pixelsInject as InjectPixelsLegacy;
